const KeyMirror = require('keymirror');

module.exports = KeyMirror({
    SAVE_ANSWERS: true,
    SEND_HEALTH_ADV_REQUEST_BEGIN: true,
    SEND_HEALTH_ADV_REQUEST_SUCCESS: true,
    SEND_HEALTH_ADV_REQUEST_ERROR: true,
});
